<template>
  <div>
    <Modal :options="{width: '40vw',type: 'danger'}" @close="$emit('close')">
      <div class="title">Eliminar configuracion</div>
      <div class="body">
        <p class="text-center">Estas por eliminar la configuración <strong>{{ configuracion.clave }}</strong>, esta acción no se puede revertir.<br/><br/>¿Deseas continuar?</p>
      </div>
      <div class="footer">
        <div class="row">
          <div class="col-sm-12 text-right">
            <button class="btn btn-primary mr-2" @click="eliminar_conf">Eliminar</button>
            <button class="btn btn-danger" @click="$emit('close')">Cancelar</button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script type="text/javascript">
  import Modal from '@/components/Modal'

  import apiConfiguracion from '@/apps/formalizacion/api/v2/configuracion'

  export default {
    components: {
      Modal
    }
    ,props: {
      configuracion: {
        type: Object
        ,default() {
          return {
            id: null
            ,clave: null
          }
        }
      }
    }
    ,methods: {
      async eliminar_conf() {
        try {
          let res =(await apiConfiguracion.eliminar_configuracion(this.configuracion.id)).data;
          this.$log.info('res', res);

          this.$emit('update');
        }catch(e) {
          this.$log.info('error',e);
          this.$helper.showAxiosError(e,'Error');
        }
      }
    }
  }
</script>